import React, { FunctionComponent } from 'react';
import { Checkbox } from '@vwfs-bronson/bronson-react';
import i18n from 'i18next';
import { FormField } from '../FormField/FormField';

interface CheckboxFormFieldProps {
  labelTranslationKey: string;
  fieldName: string;
  isDisabled?: boolean;
  testId?: string;
}

export const CheckboxFormField: FunctionComponent<CheckboxFormFieldProps> = ({
  labelTranslationKey,
  isDisabled,
  fieldName,
  testId,
}): React.JSX.Element => {
  return (
    <FormField
      type="checkbox"
      name={fieldName}
      testId={testId ?? fieldName}
      render={(fieldProps) => (
        <Checkbox {...fieldProps} disabled={isDisabled} aria-disabled={isDisabled} checked={fieldProps.value ?? false}>
          {i18n.t(labelTranslationKey)}
        </Checkbox>
      )}
    />
  );
};
